<!--
 * @Author: Latte
 * @Date: 2021-10-14 14:39:12
 * @LAstEditors: Latte
 * @LastEditTime: 2021-11-24 17:11:25
 * @FilePath: \Siui.Cloud.Medical.Web\src\components\CarouselManagement\AppAd.vue
-->
<template>
  <!-- 顶部栏 -->
  <div class="app-container">
    <div class="topbar">
      <div>
        <el-input v-model="searchValue" placeholder="" size="small" prefix-icon="el-icon-search"
                  class="search-input" @keyup.enter.native="search()" clearable/>
        <el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
                   @click.stop="search()">
          搜索
        </el-button>


      </div>
      <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click.stop="handleCreate()"
      >
        新增图片
      </el-button>
    </div>

    <div>
      <el-select v-model="curIsDeletedOption" clearable @change="curSelectOptionChange()">
        <el-option v-for="item in isDeletedOptions" :value="item.value" :label="item.label"
                   :key="item.value"></el-option>
      </el-select>
    </div>

    <!-- 内容 -->
    <el-table
        v-loading="loading"
        :data="tableData"
        :header-cell-style="{ background: '#F5F7FA' }"
        style="width: 100%; margin-bottom: 20px;margin-top: 20px"
        border
    >
      <el-table-column prop="bannersId" label="#" align="center" width="100"></el-table-column>
      <el-table-column label="创建日期" prop="CreateTime" align="center" width="180">
        <template slot-scope="scope">
          {{ scope.row.createTime | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="广告主题" align="center"/>
      <el-table-column prop="imageURL" label="广告图片" align="center">
        <template slot-scope="scope">
          <el-image
              style="height: 40px"
              fit="scale-down"
              :src="getImageUrl(scope.row.imageUrl)"
              :preview-src-list="[getImageUrl(scope.row.imageUrl)]"
          />
        </template>
      </el-table-column>
      <el-table-column
          prop="linkUrl"
          label="链接地址"
          align="center"
          show-overflow-tooltip=""
      />
      <el-table-column
          label="发布人员"
          prop="CreateUserID"
          align="center"
          width="150"
      >
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="allowSeconds" label="允许时长(s)" align="center" width="100"/>
      <el-table-column prop="pageViews" label="点击量" align="center" width="100"/>
      <el-table-column label="启用状态" prop="isEnable" align="center" width="180">
        <template #default="scope">
          <el-switch v-model="scope.row.isEnable" active-text="启用" inactive-text="未启用"
                     @change="handleSwitch(scope.$index, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button
              size="small"
              type="primary"
              @click.stop="handleUpdate(scope.$index, scope.row)"
          >
            编辑
          </el-button>
          <el-button
              size="small"
              :type="scope.row.isDeleted ? 'warning' : 'danger'"
              @click.stop="handleRemove(scope.$index, scope.row)"
          >
            {{ scope.row.isDeleted ? '恢复' : '删除' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination
        v-show="totalCount > pageSize"
        background
        :total="totalCount"
        :page-size="pageSize"
        :current-page="currentPage"
        @current-change="currentChange"
    />

    <el-dialog
        :title="dialogStatus === 'create' ? '添加首页广告' : '修改首页广告'"
        :visible.sync="dialogVisible"
        width="60%"
    >
      <el-form :model="temp" ref="adBannerForm" v-loading="uploadLoading">
        <el-form-item
            label="图片标题"
            label-width="90px"
            prop="title"
        >
          <el-input v-model="temp.title"/>
        </el-form-item>
        <el-form-item label="选择图片" label-width="90px">
          <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                     :on-change="change2DisplayLocalImage" :auto-upload="false">
            <div style="text-align: left;">
              <el-image style="width: 100px; height: 100px"
                        :src="uploadCoverFile !== null ? uploadCoverFileURL : getImageUrl(temp.imageUrl)"
                        fit="scale-down">
                <template #error>
                  <p></p>
                </template>
              </el-image>
              <br/>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>

            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label-width="90px" label="是否启用">
          <el-switch active-text="启用" inactive-text="未启用" v-model="temp.isEnable"></el-switch>
        </el-form-item>
        <!--        <el-form-item-->
        <!--            label="链接类型"-->
        <!--            label-width="90px"-->
        <!--            prop="linkType"-->
        <!--            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"-->
        <!--        >-->
        <!--          <el-select v-model="temp.linkType">-->
        <!--            <el-option label="URL地址" :value="1"></el-option>-->
        <!--            <el-option label="直播信息" :value="2"></el-option>-->
        <!--            <el-option label="APP页面标识" :value="3"></el-option>-->
        <!--            <el-option label="无类型" :value="0"></el-option>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item
            label="链接地址"
            label-width="90px"
            prop="linkUrl"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input v-model="temp.linkUrl"/>
        </el-form-item>
        <el-form-item
            label="允许时长"
            label-width="90px"
            prop="allowSeconds"
            :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
        >
          <el-input-number v-model.number="temp.allowSeconds" placeholder="单位: 秒"/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="small" @click="dialogVisible = false">
          取 消
        </el-button>
        <el-button
            size="small"
            type="primary"
            @click="dialogStatus === 'create' ? createPicture() : updatePicture()"
        >
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSlideImageBannerList,
  getSlideImageBannerOne,
  addSlideImageBanner,
  updateSlideImageBanner,
  deleteSlideImageBannerOrBack
} from "@/api/CarouselManagement/CarouselManagement";
import {getCloudUrl, getLocalFileURL} from "@/utils/urlutil";
import UserInfo from "@/components/UserInfo/UserInfo";
import {handleRes} from "@/utils/handleRes";
import {deepClone} from "@/utils";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {isVaild} from "@/utils/validate";
import {uploadFile2OSS} from "@/utils/OSSUpload";
import {getNavigationItemObj, setNavigationItemWithObj} from "@/utils/NavigationUtils";

export default {
  components: {UserInfo},
  data() {
    return {
      navigationKey: "slideImageAppAd",
      loading: false, // 加载开关
      uploadLoading: false, // 上传加载开关
      searchValue: "",
      totalCount: 0, // 列表总数
      pageSize: 10, // 单页条数
      currentPage: 1, // 当前页码
      tableData: [],
      dialogVisible: false,
      dialogStatus: "",//只有创建，修改是另一个页面
      temp: {},
      uploadCoverFile: null,
      uploadCoverFileURL: "",

      curIsDeletedOption: "",
      isDeletedOptions: [
        {
          value: "", label: "全部"
        },
        {
          value: false, label: "未删除"
        },
        {
          value: true, label: "已删除"
        },
      ],
    };
  },
  created() {
    let navigationObj = getNavigationItemObj(this.navigationKey)
    this.currentPage = navigationObj.currentPage
    this.searchValue = navigationObj.searchValue
    this.curIsDeletedOption = navigationObj.curIsDeletedOption
    if(!isVaild(this.curIsDeletedOption)){
      this.curIsDeletedOption = false;
    }

    this.getAdBannerList();
  },
  methods: {
    search() {
      this.refreshCurrentList()
    },
    refreshCurrentList() {
      this.currentPage = 1;
      this.getAdBannerList();
    },
    currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getAdBannerList()
    },
    curSelectOptionChange() {
      this.refreshCurrentList()
    },
    getImageUrl(url) {
      return getCloudUrl(url)
    },
    getAdBannerList() {
      this.loading = true;
      const params = {
        keyWord: this.searchValue,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
      };

      if (isVaild(this.curIsDeletedOption)) {
        params.where = [
          {
            "field": "isDeleted",
            "value": this.curIsDeletedOption,
            "op": "equal"
          }
        ]
      }

      //缓存请求参数，页面跳转返回可恢复状态
      setNavigationItemWithObj(this.navigationKey, {
        currentPage: this.currentPage,
        searchValue: this.searchValue,
        curIsDeletedOption: this.curIsDeletedOption
      })
      getSlideImageBannerList(params).then((res) => {
        handleRes(res, () => {
          this.totalCount = res.data.total;
          this.tableData = res.data.rows;
        })
        this.loading = false;
      });
    },
    handleSwitch(index, row) {
      const params = {
        bannersId: row.bannersId,
        isEnable: row.isEnable,
      };
      updateSlideImageBanner(params).then((res) => {
        handleRes(res, () => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getAdBannerList();
        })
      });
    },
    handleRemove(index, row) {
      let tips = row.isDeleted ? '恢复' : '删除';
      this.$confirm(`是否${tips}该广告`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
          .then(() => {
            const params = {
              bannersId: row.bannersId,
            };
            deleteSlideImageBannerOrBack(params).then((res) => {
              handleRes(res, () => {
                this.$message({
                  type: "success",
                  message: `${tips}成功`,
                });
                this.getAdBannerList();
              })

            });
          })
          .catch(() => {
            this.$message("取消操作");
          });
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs["adBannerForm"].clearValidate();
      });
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    async createPicture() {

      this.$refs["adBannerForm"].validate(async (valid) => {
        if (valid) {
          this.uploadLoading = true;
          let savepathParamsRes = await getOSSUploadInfo({
            DataType: "28",
            ID: "0",
          });
          if (!isVaild(savepathParamsRes)) {
            this.uploadLoading = false;
            return;
          }
          let savePathParams = savepathParamsRes.resultData

          //上传封面
          if (isVaild(this.uploadCoverFile)) {
            // printObj(this.uploadCoverFile.raw)
            let timestamp = new Date().valueOf();

            let uploadRes;
            let fileName;
            if (isVaild(this.uploadCoverFile)) {
              fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
              // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
              uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
                type: this.uploadCoverFile.raw.type
              }), fileName)
            }
            if (uploadRes.status === 0) {
              this.temp.imageUrl = "/" + fileName
              // console.log(this.form.liveCover)
            } else {
              this.$message({
                type: "error",
                message: "上传失败"
              })
            }
            this.$refs.uploadCoverRef.clearFiles();
          }

          const params = deepClone(this.temp);
          params.linkType = 1
          addSlideImageBanner(params).then((res) => {
            handleRes(res, () => {
              this.refreshCurrentList()
            })
            this.dialogVisible = false
            this.uploadLoading = false;
          });
        }
      });
    },
    handleUpdate(index, row) {
      // this.temp = Object.assign({}, row);
      // this.dialogStatus = "update";
      // this.dialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs["adBannerForm"].clearValidate();
      // });
      this.$router.push({
        path: 'appAdDetail',
        query: {
          bannersId: row.bannersId,
        }
      })
    },
    updatePicture() {
      this.$refs["adBannerForm"].validate((valid) => {
        if (valid) {
          console.log(this.temp);
          const params = this.temp;
          updateAdBanner(params).then((res) => {
            console.log(res);
            // TODO
          });
        }
      });
    },
  },
};
</script>

<style>
</style>